import React from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AiAssistedSearchBanner } from '@thd-olt-component-react/ai-assisted-search-banner';

export const IN_GRID_COMPONENT_REGISTRY = {
  aiAssistedSearchBanner: () => (
    <ErrorBoundary name="ai-assisted-search-banner">
      <QueryProvider cacheKey="ai-assisted-search-banner">
        <AiAssistedSearchBanner />
      </QueryProvider>
    </ErrorBoundary>
  )
};
